import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("homiin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const inr = (v) =>
  "₹" + Math.round(v || 0).toLocaleString("en-IN");

export async function downloadPdf(id, number) {
  const res = await api.get(`/quotes/${id}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `homiin-quotation-${number}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1705326701287-346fc37a2c86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  living: "https://images.unsplash.com/photo-1600494448850-6013c64ba722?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen: "https://images.unsplash.com/photo-1772442363851-738a548f6c5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  plan: "https://images.unsplash.com/photo-1603901622056-0a5bee231395?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  plan2: "https://images.unsplash.com/photo-1698846296220-e44d9d4b9100?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bedroom: "https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bedroom2: "https://images.unsplash.com/photo-1696762932825-2737db830bbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  japandi: "https://images.unsplash.com/photo-1772797583328-f83bc3f94f80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
